import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import useCrudStore from '@/hooks/useCrudStore'

import {
  IFlatDealCreateForm,
  IFlatDealBuyForm,
  IFlatDealFilter
} from '@/apps/traforama/interfaces/flatDeals'
import {
  fetchItems,
  fetchItem,
  createItem,
  buyItem,
  changeDealState,
  fetchStats,
  fetchEditItem,
  fetchBuffetReport
} from '@/apps/traforama/api/flatDeals'

export const defaultFilter: IFlatDealFilter = {
  traffic_qualities: [],
  spot_ids: [],
  query: '',
  website: '',
  deal_start: '',
  deal_stop: '',
  deal_types: '',
  availability: [],
  pub_types: [],
  devices: [],
  countries: [],
  size_id: undefined
}

export const useFlatDealsStore = defineStore('flatDeals', () => {
  const {
    currentItems,
    total,
    filter,
    items,
    current,
    listLoading,
    itemsLoading,
    currentPage,
    FetchItems,
    SaveItem,
    SetCurrentPage,
    SetFilters,
    error,
    itemById,
    setItem,
    setCurrent,
    removeItem
  } = useCrudStore({
    defaultFilter,
    fetchItems,
    createItem,
    updateItem: createItem
  })

  const FetchItem = async (id: string, edit: boolean = false) => {
    itemsLoading.value[id] = true
    try {
      const response = await (edit ? fetchEditItem(id) : fetchItem(id))
      setCurrent(response.data)
      setItem(response.data)
    } catch (e: any) {
      error.value = e.toString()
    } finally {
      itemsLoading.value = {}
      error.value = null
    }
  }

  const BuyItem = async (item: IFlatDealBuyForm) => {
    itemsLoading.value[item.deal_name] = true
    try {
      const response = await buyItem(item)
      return response.data
    } catch (e: any) {
      error.value = e.toString()
      throw e
    } finally {
      itemsLoading.value = {}
      error.value = null
    }
  }

  const ChangeDealState = async (
    id: number,
    event: string,
    reason?: string
  ) => {
    itemsLoading.value[id] = true
    try {
      const response = await changeDealState(id, event, reason)
      return response
    } catch (e: any) {
      error.value = e.toString()
    } finally {
      itemsLoading.value = {}
      error.value = null
    }
  }

  const FetchStats = async (id: number) => {
    itemsLoading.value[`${id}_stat`] = true
    try {
      const response = await fetchStats(id)
      return response
    } catch (e: any) {
      error.value = e.toString()
    } finally {
      itemsLoading.value = {}
      error.value = null
    }
  }

  const FetchBuffetReport = async () => {
    listLoading.value = true
    try {
      const response = await fetchBuffetReport()
      return response
    } catch (e: any) {
      error.value = e.toString()
    } finally {
      listLoading.value = false
      error.value = null
    }
  }

  return {
    // State
    items,
    current,
    currentItems,
    currentPage,
    filter,
    total,
    listLoading,
    itemsLoading,
    // Actions
    FetchItems,
    FetchItem,
    SaveItem,
    SetCurrentPage,
    SetFilters,
    BuyItem,
    ChangeDealState,
    FetchStats,
    FetchBuffetReport,

    // Getters
    itemById
  }
})
